<template>
    <div class="app-container">
        <el-row :gutter="20">
            <!--部门数据-->
            <el-col :span="4" :xs="24">
                <div class="head-container">
                    <el-input v-model="deptName" placeholder="请输入部门名称" clearable size="small"
                        prefix-icon="el-icon-search" style="margin-bottom: 20px" />
                </div>
                <div class="head-container">
                    <el-tree :data="deptOptions" :props="defaultProps" :expand-on-click-node="false"
                        :filter-node-method="filterNode" ref="tree" default-expand-all @node-click="handleNodeClick" />
                </div>
            </el-col>
            <!--用户数据-->
            <el-col :span="20" :xs="24">
                <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px">
                    <el-form-item label="用户名称" prop="userName">
                        <el-input v-model="queryParams.userName" placeholder="请输入用户名称" clearable size="small"
                            style="width: 240px" />
                    </el-form-item>
                    <el-form-item label="手机号码" prop="phonenumber">
                        <el-input v-model="queryParams.phonenumber" placeholder="请输入手机号码" clearable size="small"
                            style="width: 240px" />
                    </el-form-item>
                    <el-form-item label="权限编号" prop="phonenumber">
                        <el-input v-model="queryParams.phonenumber" placeholder="请输入权限编号" clearable size="small"
                            style="width: 240px" />
                    </el-form-item>
                    <el-form-item label="开始时间" prop="startDate">
                        <el-date-picker type="date" placeholder="选择开始日期" size="small" v-model="queryParams.startTime"
                            style="width: 100%;" value-format="timestamp" :picker-options="beginDate"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="endDate">
                        <el-date-picker type="date" placeholder="选择结束日期" size="small" v-model="queryParams.endTime"
                            style="width: 100%;" value-format="timestamp" :picker-options="endDate"></el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="状态" prop="status">
                        <el-select v-model="queryParams.status" placeholder="用户状态" clearable size="small"
                            style="width: 240px">
                            <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel"
                                :value="dict.dictValue" />
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange">
                    <!-- <el-table-column type="selection" width="50" align="center" /> -->
                    <el-table-column label="姓名" align="center" prop="userName" />
                    <el-table-column label="部门" align="center" prop="dept.deptName" />
                    <el-table-column label="手机号码" align="center" prop="phonenumber" width="120" />
                    <el-table-column label="人脸照片" align="center" key="photoPath">
                        <template slot-scope="scope">
                            <div style="width:50px;height:50px;margin:0 auto;">
                                <el-image style="width:100%;height:100%;" :src="scope.row.photoPath"
                                    v-if="scope.row.photoPath" :preview-src-list="[scope.row.photoPath]" />
                            </div>
                        </template>

                    </el-table-column>
                    <!-- <el-table-column label="上传时间" align="center"> </el-table-column>
                    <el-table-column label="备注" align="center"> </el-table-column> -->
                    <el-table-column label="操作" align="center" width="260" class-name="small-padding fixed-width">
                        <template slot-scope="scope">
                            <!-- <el-button size="mini" type="text" @click="view(scope.row)">查看
                            </el-button> -->
                            <!-- <el-button size="mini" type="text" @click="handleStop(scope.row)">禁用
                            </el-button> -->
                            <el-button size="mini" type="text" @click="handleEdit(scope.row)">上传照片
                            </el-button>
                            <!-- <el-button size="mini" type="text" @click="handleDelete(scope.row)">删除
                            </el-button> -->
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination v-show="total > 0" background :page-sizes="[10, 20, 30, 50]"
                    :current-page.sync="queryParams.pageNum" :page-size="queryParams.pageSize"
                    layout="total, prev, pager, next,sizes" @current-change="handleCurrentChange" :total="total"
                    @size-change="handleSizeChange" />

            </el-col>
        </el-row>


        <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
            <el-image v-if="userImage" fit="contain" style="width:100%;" :src="userImage"> </el-image>
            <el-upload v-if="upload.title == '上传照片'" ref="upload" :limit="1" accept=".jpg, .png, .jpeg"
                :headers="upload.headers" :action="upload.url" :disabled="upload.isUploading"
                :on-progress="handleFileUploadProgress" :on-success="handleFileSuccess" drag
                :before-upload="beforeAvatarUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <span>仅允许jpg、png、jpeg格式文件。</span>
            </el-upload>

            <div slot="footer" class="dialog-footer">
                <el-button v-if="!upload.isUploading && upload.title == '上传照片'" size="small" type="primary"
                    @click="submitFileForm">确
                    定</el-button>
                <el-button v-if="upload.isUploading && upload.title == '上传照片'" type="primary" size="small"
                    :loading="true">导入中</el-button>
                <el-button size="small" @click="upload.open = false">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="title" :visible.sync="openView" width="400px" append-to-body>
            <el-image style="width:100%;" fit="contain" :src="userImage"> </el-image>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="openView = false">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data() {
        return {
            srcList: [],
            openView: false,
            title: "",
            userImage: "",
            paramsData: { userId: "" },
            // 用户导入参数
            upload: {
                // 是否显示弹出层（用户导入）
                open: false,
                // 弹出层标题（用户导入）
                title: "照片上传",
                // 是否禁用上传
                isUploading: false,

                // 设置上传的请求头部
                headers: {
                    Authorization: localStorage.access_token
                },
                // 上传的地址
                url: "/api/safeSign/userFace/upload"
            },
            // 保证开始时间小于结束时间
            beginDate: {
                disabledDate: (time) => {
                    if (this.queryParams.endTime) {
                        return (
                            time >= this.queryParams.endTime
                        )
                    }
                }
            },
            // 保证结束时间大于开始时间
            endDate: {
                disabledDate: (time) => {
                    // console.log("end",time);
                    if (this.queryParams.startTime) {
                        return time <= this.queryParams.startTime
                    }
                }
            },
            // 遮罩层
            loading: false,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 用户表格数据
            userList: null,
            // 弹出层标题
            title: "",
            // 部门树选项
            deptOptions: undefined,
            // 是否显示弹出层
            open: false,
            // 部门名称
            deptName: undefined,
            // 默认密码
            initPassword: undefined,
            // 日期范围
            dateRange: [],
            // 状态数据字典
            statusOptions: [],
            // 性别状态字典
            sexOptions: [],
            // 岗位选项
            postOptions: [],
            // 角色选项
            roleOptions: [],
            // 表单参数
            form: {},
            defaultProps: {
                children: "children",
                label: "label"
            },
            // 用户导入参数
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                userName: undefined,
                phonenumber: undefined,
                status: undefined,
                deptId: undefined,
                startTime: undefined,
                endtime: undefined
            },
            // 列信息
            columns: [
                { key: 0, label: `用户编号`, visible: true },
                { key: 1, label: `用户名称`, visible: true },
                { key: 2, label: `用户昵称`, visible: true },
                { key: 3, label: `部门`, visible: true },
                { key: 4, label: `手机号码`, visible: true },
                { key: 5, label: `状态`, visible: true },
                { key: 6, label: `创建时间`, visible: true }
            ],
            // 表单校验
            rules: {
                userName: [
                    { required: true, message: "用户名称不能为空", trigger: "blur" }
                ],
                nickName: [
                    { required: true, message: "用户昵称不能为空", trigger: "blur" }
                ],
                cardId: [
                    { required: true, message: "身份证不能为空", trigger: "blur" }
                ],
                // phonenumber: [
                //   { required: true, message: "手机号不能为空", trigger: "blur" }
                // ],
                password: [
                    { required: true, message: "用户密码不能为空", trigger: "blur" }
                ],
                email: [
                    {
                        type: "email",
                        message: "'请输入正确的邮箱地址",
                        trigger: ["blur", "change"]
                    }
                ],
                phonenumber: [
                    {
                        required: true,
                        pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                        message: "请输入正确的手机号码",
                        trigger: "blur"
                    }
                ]
            }
        }
    },
    watch: {
        // 根据名称筛选部门树
        deptName(val) {
            this.$refs.tree.filter(val);
        }
    },
    created() {
        this.getTreeselect();
        this.getList();

    },
    methods: {

        view(row) {
            if (row.photoPath) {
                console.log('查看', row)
                this.srcList = [row.photoPath]
                // this.title = "查看照片"
                // this.getImage();
                // this.userImage = row.photoPath
                // this.openView = true;
            } else {
                this.$message.error(`暂无照片`);
            }

        },
        handleEdit(row) {
            console.log('修改', row)
            this.upload.isUploading = false;
            this.upload.title = "上传照片"
            this.paramsData.userId = row.userId;
            this.upload.url = "/api/safeSign/userFace/upload?userId=" + row.userId;
            // this.getImage();
            this.userImage = ""
            this.upload.open = true;
        },
        handleStop(row) {
            console.log('禁用', row)
        },
        handleDel(row) {
            console.log('删除', row)
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        /** 查询用户列表 */
        getList() {
            this.loading = true;
            this.$http.get(`/api/system/user/list`, {
                params: this.queryParams
            }).then(res => {
                this.userList = res.data.rows
                this.total = res.data.total
                this.loading = false;

            })
        },
        // 文件上传中处理
        handleFileUploadProgress(event, file, fileList) {
            this.upload.isUploading = true;
        },
        // 文件上传成功处理
        handleFileSuccess(response, file, fileList) {
            this.upload.isUploading = false;
            this.$refs.upload.clearFiles();
            console.log(response)
            if (response.code == 200) {
                this.upload.open = false;
                this.userImage = response.data
                this.$message.success(`上传成功!`);
            } else {
                this.$message.error(`${response.msg}`);
            }
        },
        // 提交上传文件
        submitFileForm() {
            this.$refs.upload.submit();
        },
        // 上传之前
        beforeAvatarUpload(file) {
            if (this.paramsData.userId == "") {
                return false;
            }
            return true;
        },
        getImage() {
            this.userImage = "";
            this.$http.get(`/api/userFace/getPhotoDetail?userId=${this.paramsData.userId}`).then(res => {
                if (res.data.code == 200) {
                    this.userImage = res.data.data.photoPath
                } else {
                    this.$message.error(`${res.data.msg}`);
                }
                // this.deptOptions = res.data.data
            })
        },
        /** 查询部门下拉树结构 */
        getTreeselect() {
            this.$http.get(`/api/system/dept/treeselect2`).then(res => {
                this.deptOptions = res.data.data
            })
        },
        // 筛选节点
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        // 节点单击事件
        handleNodeClick(data) {
            this.queryParams.deptId = data.id;
            this.getList();
        },
        // 用户状态修改
        handleStatusChange(row) {
            let text = row.status === "0" ? "启用" : "停用";
            this.$confirm('确认要"' + text + '""' + row.userName + '"用户吗?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function () {
                return changeUserStatus(row.userId, row.status);
            }).then(() => {
                this.msgSuccess(text + "成功");
            }).catch(function () {
                row.status = row.status === "0" ? "1" : "0";
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                userId: undefined,
                deptId: undefined,
                userName: undefined,
                nickName: undefined,
                password: undefined,
                phonenumber: undefined,
                email: undefined,
                sex: undefined,
                status: "0",
                remark: undefined,
                postIds: [],
                roleIds: []
            };
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.dateRange = [];
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                userName: undefined,
                phonenumber: undefined,
                status: undefined,
                deptId: undefined
            };
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.single = selection.length != 1;
            this.multiple = !selection.length;
        },

        /** 删除按钮操作 */
        handleDelete(row) {
            const userIds = row.userId || this.ids;
            this.$confirm('是否确认删除用户编号为"' + userIds + '"的数据项?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function () {
                return delUser(userIds);
            }).then(() => {
                this.getList();
                this.msgSuccess("删除成功");
            })
        },

    }
};
</script>
<style>
.app-container {
    padding-top: 20px;
}
</style>

